// import React from 'react';

// const twitterWidgetJs = 'https://platform.twitter.com/widgets.js';
// const methodName = 'createTweet';

// const TweetEmbed = (props) => {
//   const ref = React.useRef(null);
//   const [loading, setLoading] = React.useState(true);

//   React.useEffect(() => {
//     let isComponentMounted = true;
//     const script = require('scriptjs');
//     script(twitterWidgetJs, 'twitter-embed', () => {
//       if (!window.twttr) {
//         console.error('Failure to load window.twttr, aborting load');
//         return;
//       }
//       if (isComponentMounted) {
//         if (!window.twttr.widgets[methodName]) {
//           console.error(
//             `Method ${methodName} is not present anymore in twttr.widget api`
//           );
//           return;
//         }

//         window.twttr.widgets[methodName](
//           props.tweetId,
//           ref?.current,
//           props.options
//         ).then((element) => {
//           setLoading(false);
//           if (props.onLoad) {
//             props.onLoad(element);
//           }
//         });
//       }
//     });

//     // cleaning up
//     return () => {
//       isComponentMounted = false;
//     };
//   }, []);

//   return (
//     <React.Fragment>
//       {loading && <React.Fragment>{props.placeholder}</React.Fragment>}
//       <div className="flex items-start justify-center w-full" ref={ref} />
//     </React.Fragment>
//   );
// };

// export default TweetEmbed;

import React from 'react';
import { Tweet } from 'react-tweet';

const twitterWidgetJs = 'https://platform.twitter.com/widgets.js';
const methodName = 'createTweet';

const TweetEmbed = (props) => {
  // const ref = React.useRef(null);
  // const [loading, setLoading] = React.useState(true);

  // React.useEffect(() => {
  //   let isComponentMounted = true;
  //   const script = require('scriptjs');
  //   script(twitterWidgetJs, 'twitter-embed', () => {
  //     if (!window.twttr) {
  //       console.error('Failure to load window.twttr, aborting load');
  //       return;
  //     }
  //     if (isComponentMounted) {
  //       if (!window.twttr.widgets[methodName]) {
  //         console.error(
  //           `Method ${methodName} is not present anymore in twttr.widget api`
  //         );
  //         return;
  //       }

  //       window.twttr.widgets[methodName](
  //         props.tweetId,
  //         ref?.current,
  //         props.options
  //       ).then((element) => {
  //         setLoading(false);
  //         if (props.onLoad) {
  //           props.onLoad(element);
  //         }
  //       });
  //     }
  //   });

  //   // cleaning up
  //   return () => {
  //     isComponentMounted = false;
  //   };
  // }, []);

  return (
    <React.Fragment>
      {/* {loading && <React.Fragment>{props.placeholder}</React.Fragment>} */}
      <div className="light flex w-full items-start justify-center">
        <Tweet id={props.tweetId} />
      </div>
    </React.Fragment>
  );
};

export default TweetEmbed;
